import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const reopenReturn = {
  name: "reopenReturn" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.null(),
};
